import React from 'react'
import { sortBy } from 'lodash-es'
import { Box, Timeline, TimelineProps } from '@node-space/ui-components'
import { InternalTransferTransactionActivities } from 'types/transaction'

interface InternalTransferTransactionActivityProps {
  transactionActivities: InternalTransferTransactionActivities[]
}

const InternalTransferTransactionActivity = ({
  transactionActivities,
}: InternalTransferTransactionActivityProps) => {
  const sortedActivities = sortBy(transactionActivities, ['step'])
  const lastStep = sortedActivities?.[sortedActivities.length - 1]?.step

  const activities: TimelineProps['items'] = sortedActivities?.map(activity => {
    return {
      variant: activity?.step === lastStep ? 'success' : 'info',
      date: new Date(activity?.dateCreated),
      Title: <span>{activity?.description ?? ''}</span>,
    }
  })

  return (
    <Box paddingB={16}>
      <Timeline items={activities} />
    </Box>
  )
}
export default InternalTransferTransactionActivity
